import React, { useEffect, useState } from 'react'
import Barcode from 'react-barcode'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { wtHrefHashGetVars } from 'src/helpers/commons/HrefHash'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { CButtonToolbar, CButton, CToaster, CToast, CToastHeader, CToastBody } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilPrint, cilX } from '@coreui/icons';
import Loading from 'src/helpers/commons/loader'

export default function ItemBarcodes() {

    const itemHash = wtHrefHashGetVars()
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        wtApiCall(
            'grn_barcodes/' + itemHash.id,
            {},
            'get',
            (response) => {
                setData(response.data.item_barcodes)
                setIsLoading(false)
            },
            (error) => {
                setIsLoading(false)
                lzNotifyErrorMessageFromResult(error)
            }
        )
    }, [])

    if (isLoading) return Loading
    return (
        <div>
            <style>
                {`
          @media print {
            body * {
              visibility: hidden;
            }
            #print-area, #print-area * {
              visibility: visible;
            }
            #print-area {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
        `}
            </style>
            {data.length && (
                <>
                    <CButtonToolbar style={{ padding: '10px' }}>
                        <CButton color='success' className='text-white' onClick={() => window.print()} style={{ marginLeft: '90%', marginRight: 10 }}><CIcon icon={cilPrint} /> Print</CButton>
                        <CButton color='danger' className='text-white' onClick={() => window.close()}><CIcon icon={cilX} /> Close</CButton>
                    </CButtonToolbar>
                    <hr />
                    <div id='print-area'>

                        {data.map((item) => (
                            <>
                                <br />
                                {item.item_serial && (
                                    <>
                                        <span> <b>Serial No: {item.item_serial.serial}</b></span>
                                        <br />
                                    </>
                                )}
                                <Barcode value={item.barcode} />
                                <br />
                            </>
                        ))}
                    </div>
                </>)
            }

            {data.length === 0 && (
                <center><h2>No barcodes to display</h2></center>
            )}
        </div>
    )
}
